import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

const RouteWithLayout = props => {
  const {
    layout: Layout,
    component: Component,
    userMessageDomain,
    isLoading,
    ...rest
  } = props;

  return (
    !isLoading && (
      Layout ?
        <Route
          {...rest}
          render={matchProps => (
            <Layout userMessageDomain={userMessageDomain}>
              <Component {...matchProps} />
            </Layout>
          )}
        />
        :
        <Route
          {...rest}
          render={matchProps => (
            <Component {...matchProps} />
          )}
        />
    )
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any,
  path: PropTypes.string
};

export default RouteWithLayout;
